import type { MediaType } from '@/helpers/enums';
import type { ILevelConfig } from '../components/MissionLevels/helpers';

export interface IResponsiveImageSrc {
  desk: string;
  mob: string;
}

export type ICardHudConfig =
  | {
      kind: 'svg';
      viewBox: string;
      fillPath: string;
      strokePath: string;
    }
  | {
      kind: 'image';
      src: string;
    };

interface IHeadlinePromoPageConfigBase {
  // CMS lookup key - not necessarily the same as the page's URL; use
  // `route` for navigation.
  promoKey: string;
  route: string;
  namespace: string;
  cardHud: ICardHudConfig;
  levelsConfig: ILevelConfig[];
  // Breakpoint at/below which the levels carousel switches to a single
  // slide per view instead of a grouped desktop layout - defaults to
  // MediaType.MOBILE when omitted.
  levelsMobileBreakpoint?: MediaType;
  disableAnimations?: boolean;
  dateFormat?: string;
  hideHowToGamesCountLabel?: boolean;
  hideHowToDescription?: boolean;
  faqBgImage?: string;
  progressBarVariant?: 'pill';
  // Skips the balance check and always shows the deposit CTA for
  // authenticated users - for deposit-count-based promos where playing
  // without depositing again can't progress the level anyway.
  ctaAlwaysDeposit?: boolean;
  allowedCountries?: string[];
  disallowedCountries?: string[];
}

export type IHeadlinePromoPageConfig = IHeadlinePromoPageConfigBase &
  (
    | {
        // groupPrefix is unused when the backend issues each level's full
        // name as the group id verbatim, so the type forbids setting it.
        useFullNameAsGroupId: true;
        groupPrefix?: never;
      }
    | {
        useFullNameAsGroupId?: false;
        groupPrefix: string;
      }
  );

export const pickResponsiveSrc = (
  src: IResponsiveImageSrc,
  isMobileDevice?: boolean
) => (isMobileDevice ? src.mob : src.desk);
